import { sendToJava } from "@tipico/java-streams";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { of, Subscription } from "rxjs";

export const NAVIGATION_STREAM: string = "Navigation";

export function navigate<T extends RouteComponentProps>(
    ComponentUnderRoute:
        | React.ComponentType<T>
        | React.ComponentType<{}>
        | null,
    route: string
) {
    return class extends React.Component<T> {
        private navigationSubscription: Subscription = new Subscription();

        public componentDidMount() {
            if (this.props.location) {
                // false positive deprecation warning
                // reference issue: https://github.com/palantir/tslint/issues/4522
                // tslint:disable-next-line: deprecation
                this.navigationSubscription = of({
                    parameters: this.buildParams(this.props.location.search),
                    route
                })
                    .pipe(sendToJava(NAVIGATION_STREAM))
                    .subscribe();
            }
        }
        public componentWillUnmount() {
            this.navigationSubscription.unsubscribe();
        }
        public render() {
            if (ComponentUnderRoute) {
                return <ComponentUnderRoute {...this.props} />;
            } else {
                return null;
            }
        }

        private buildParams(searchQuery: string) {
            if (!searchQuery) {
                return {};
            }

            const parameters: { [key: string]: string } = {};

            new URLSearchParams(searchQuery).forEach(
                (value: string, key: string) => {
                    parameters[key] = value;
                }
            );

            return parameters;
        }
    };
}

export function navigateToLegacy(route: string) {
    return navigate(null, route);
}
